import {
    faTwitter as Twitter,
    faFacebookF as Facebook,
    faInstagram as Instagram,
    faPinterestP as Pinterest,
} from '@fortawesome/free-brands-svg-icons';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '../FontAwesomeIcon';

// El script de Pinterest solo hace falta donde está el botón "Pin": se carga aquí, async,
// en lugar de en todas las páginas. Si ya está cargado, vuelve a activar los botones nuevos.
const usePinterest = () => {
    useEffect(() => {
        if (window.PinUtils) {
            window.PinUtils.build();
            return;
        }
        if (document.getElementById('pinterest-pinit')) return;
        const script = document.createElement('script');
        script.id = 'pinterest-pinit';
        script.async = true;
        script.src = 'https://assets.pinterest.com/js/pinit.js';
        document.body.appendChild(script);
    }, []);
};

const ShareMediaNav = (props) => {
    usePinterest();
    const fullUrl = window.location.href;
    return (
        <ul className='d-flex justify-content-between ps-3' style={{ width: '140px', marginBottom: 0 }}>
            <li className='circle-btn-orange'>
                <a
                    href={'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href}
                    aria-label={`go to Facebook`}
                    target='_blank'
                    rel='noreferrer noopener'
                >
                    <FontAwesomeIcon icon={Facebook} className='fa-lg' />
                </a>
            </li>
            <li className='circle-btn-orange'>
                <a
                    href={'https://twitter.com/intent/tweet?url=' + window.location.href}
                    aria-label={`go to Twitter`}
                    target='_blank'
                    rel='noreferrer noopener'
                >
                    <FontAwesomeIcon icon={Twitter} className='fa-lg' />
                </a>
            </li>
            <li className='circle-btn-orange'>
                <a
                    data-pin-do="buttonBookmark"
                    data-pin-custom="true"
                    data-pin-round="true"
                    href={"http://pinterest.com/pin/create/button/?url={"+fullUrl+"}&media={"+props.image+"}&description={I want to share this awesome recipe}"}
                    target="_blank"
                >
                    <FontAwesomeIcon icon={Pinterest} className='fa-lg' />
                </a>
            </li>
        </ul>
    );
};

export default ShareMediaNav;
